/*
    sidebar component should be a component usable for all main views
*/
import React, { useEffect, useState } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";
import { $, Foundation } from "../../../../../vendor";
import Biscuit from "../../../../utils/Biscuit";
import { locationActions, useSelector } from "inbooma-api";
import SidebarMenu from "../../reservations/components/SidebarMenu";
import SidebarFilter from "../../../components/SidebarFilter";
import { getApiHost } from "../../../../Sync";
import { getAllUrlParams } from "../../../../utils";
import * as FileSaver from "../../../../../vendor/FileSaver";
import { getFilterData } from "../../../../utils/Helper";
import SidebarFooter from "../../../components/SidebarFooter";

const ResourceSidebar = (props) => {
  let language = Biscuit.get("user.lang").replace("-", "_");

  let tempData = [{ id: "all", name: t("all") }];

  for (let index = 0; index < props.locations.length; index++) {
    tempData.push(props.locations[index]);
  }

  let contingents = props.contingents;

  tempData = [{ id: "all", name: t("all") }];
  for (let index = 0; index < contingents.length; index++) {
    tempData.push(contingents[index]);
  }
  contingents = tempData;

  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const allUrlParams = getAllUrlParams(window.location.href);
  allUrlParams.location_name !== undefined && delete allUrlParams.location_name;
  const [locationFilter, setLocationFilter] = useState("all");
  const cleanState = {
    locationFilter: false,
    statusFilter: false,
    contingentFilter: false,
    resourceNbrFilter: false,
  };
  const [usedFilterCount, setUsedFilterCount] = useState({
    locationFilter: allUrlParams.location_id !== undefined ? true : false,
    contingentFilter: allUrlParams.contingent_id !== undefined ? true : false,
    statusFilter: allUrlParams.status !== undefined ? true : false,
    resourceNbrFilter: false,
  });
  const [filterCount, setFilterCount] = useState(
    Object.keys(allUrlParams).length > 0 ? Object.keys(allUrlParams).length : 0,
  );
  const [contingentFilter, setContingentFilter] = useState(
    searchParams.get("contingent_id") !== null ? searchParams.get("contingent_id") : "all",
  );

  const [statusFilter, setStatusFilter] = useState(
    searchParams.get("status") !== null ? searchParams.get("status") : "all",
  );
  const [findFilter, setFindFilter] = useState(
    searchParams.get("find") !== null && searchParams.get("find") !== "CheckedInStatus"
      ? searchParams.get("find")
      : "all",
  );
  const [checkedInStatusFilter, setCheckedInStatusFilter] = useState("all");

  const [resourceNbrFilter, setResourceNbrFilter] = useState("");

  const _locationsResults = useSelector((state) => state.locations_data.locations);
  const [location, setLocation] = useState(
    searchParams.get("location_id") !== null && searchParams.get("location_name") !== null
      ? { name: searchParams.get("location_name") }
      : undefined,
  );
  const [_resetFilter, _setResetFilter] = useState(props.resetFilter);
  const [globalFilter, setGlobalFilter] = useState({}); // set empty object, there are no filters set by default

  useEffect(() => {
    if (!_resetFilter) return;

    if (_resetFilter) {
      resetFilter(false);
    }
    _setResetFilter(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_resetFilter]);

  const handleChangeTo = (value) => {
    var globalClone = {};

    // update global filter
    Object.assign(globalClone, globalFilter); // get current values of global filter (all filter)

    setGlobalFilter(globalClone);
    props.filterChangedHandle(globalClone); // cloned object must be used because global filter is not yet updated
  };

  const onFilterCountChangeHandle = (value) => {
    let clone = { ...value };
    let count = 0;
    for (const [type, val] of Object.entries(clone)) {
      if (val) {
        count++;
      }
    }
    if (count < 1) {
      count = 0;
      $("#inb-selected-filters").addClass("hidden");
    } else {
      $("#inb-selected-filters").removeClass("hidden");
    }
    setFilterCount(count);
  };

  const resetFilter = (dispatch = true) => {
    let clone = {
      find: "CheckedInStatus",
    };
    setStatusFilter("all");
    setLocation(undefined);
    setLocationFilterState({
      value: "",
      isOpen: false,
    });
    setContingentFilter("all");
    setResourceNbrFilter("");
    setFilterCount(0);
    setGlobalFilter(clone);
    setUsedFilterCount(cleanState);
    onFilterCountChangeHandle(cleanState);
    if (dispatch) {
      props.filterChangedHandle(clone, {
        sort: "resource_nbr",
        direction: "desc",
      });
    } else {
      props.setFilter(clone);
    }
    const newRelativePathQuery = window.location.pathname;
    history.pushState(null, "", newRelativePathQuery);
  };

  const onContingentFilterChange = (val) => {
    if (val === "all" || typeof val.target === "undefined") {
      val = { target: { value: "all" } };
    }
    setContingentFilter(val.target.value); // set status filter
    let clone = { ...props.filter };
    let clone2 = { ...usedFilterCount }; // get current filter settings (all filter)

    if (val.target.value !== "all") {
      // add status filter to global filter
      clone.contingent_id = val.target.value;
      clone2.contingentFilter = true;
      searchParams.set("contingent_id", val.target.value);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      // remove status filter from global filter
      delete clone["contingent_id"];
      clone2.contingentFilter = false;
      searchParams.delete("contingent_id");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
    setUsedFilterCount(clone2);
    setGlobalFilter(clone);
    onFilterCountChangeHandle(clone2);
    props.filterChangedHandle(clone); // cloned object must be used because global filter is not yet updated
  };

  const onStatusFilterChange = (val) => {
    if (val !== "inprogress") {
      setStatusFilter(val); // set status filter
    } else {
      setFindFilter(val);
      setStatusFilter(val);
    }
    let clone = { ...props.filter };
    let clone2 = { ...usedFilterCount }; // get current filter settings (all filter)

    if (val !== "all" && val !== null && val !== "inprogress") {
      // add status filter to global filter
      if (clone["find"] === "inprogress") {
        delete clone["find"];
      }
      clone.status = val;
      clone2.statusFilter = true;
    } else if (val === "inprogress") {
      delete clone["status"];
      clone["find"] = val;
      clone2.statusFilter = true;
    } else {
      // remove status filter from global filter
      delete clone["status"];
      if (clone["find"] === "inprogress") {
        delete clone["find"];
      }
      clone2.statusFilter = false;
      setStatusFilter("all");
    }
    setUsedFilterCount(clone2);
    setGlobalFilter(clone);
    onFilterCountChangeHandle(clone2);
    props.filterChangedHandle(clone); // cloned object must be used because global filter is not yet updated
    if (val !== "all" && val !== null && val !== "inprogress") {
      searchParams.delete("find");
      searchParams.set("status", val);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else if (val === "inprogress") {
      searchParams.delete("status");
      searchParams.set("find", val);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      searchParams.delete("find");
      searchParams.delete("status");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
  };

  const onCheckedInStatusFilterChange = (val) => {
    setCheckedInStatusFilter(val);
    let clone = {};
    Object.assign(clone, props.filters); // get current filter settings (all filter)

    if (val != "all") {
      // add status filter to global filter
      clone.checkedInStatus = val;
    } else {
      // remove status filter from global filter
      delete clone["checkedInStatus"];
    }
    setGlobalFilter(clone);
    // onFilterCountChangeHandle(clone2);
    props.filterChangedHandle(clone); // cloned object must be used because global filter is not yet updated
  };

  const onResourceNbrFilterChange = (val) => {
    if (val === "" || typeof val.target === "undefined") {
      val = { target: { value: "" } };
    }
    setResourceNbrFilter(val.target.value); // set status filter
    let clone = { ...props.filter };
    let clone2 = { ...usedFilterCount }; // get current filter settings (all filter)
    if (val.target.value !== "") {
      // add status filter to global filter
      clone.resource_nbr = val.target.value;
      clone2.resourceNbrFilter = true;
      clone2.contingentFilter = false;
      clone2.statusFilter = false;
      clone2.locationFilter = false;
      setStatusFilter("all");
      setLocation(undefined);
      setLocationFilterState({
        value: "",
        isOpen: false,
      });
      setContingentFilter("all");
    } else {
      // remove status filter from global filter
      delete clone["resource_nbr"];
      clone2.resourceNbrFilter = false;
    }
    delete clone["contingent_id"];
    delete clone["status"];
    delete clone["location_id"];
    setUsedFilterCount(clone2);
    setGlobalFilter(clone);
    onFilterCountChangeHandle(clone2);
    props.filterChangedHandle(clone);
  };

  let _dropdown = null;

  const _initDropdown = (ev) => {
    ev.preventDefault();

    if (_dropdown === null) {
      _dropdown = new Foundation.Dropdown($("#inb-c-sidebar .inb-dropdown"));
    }
    _dropdown.open();

    return false;
  };

  // ****************************************************************************** filter location select *************************************************************

  const [locationFilterState, setLocationFilterState] = useState({
    isOpen: false,
    value: location == null || location === undefined ? "" : location,
  });

  const locationFilterSelectHandle = (location) => {
    setLocation(location == null ? null : location);
    let clone2 = { ...usedFilterCount };
    const filterVal = location == null ? "all" : location.id;
    setLocationFilter(filterVal); // set status filter
    let clone = { ...props.filter }; // get current filter settings (all filter)

    if (filterVal !== "all") {
      // add status filter to global filter
      clone.location_id = filterVal;
      queryLocationFilterSelectHandle(null, "");
      clone2.locationFilter = true;
    } else {
      console.log("inside");
      // remove status filter from global filter
      delete clone["location_id"];
      clone2.locationFilter = false;
    }
    setUsedFilterCount(clone2);
    setGlobalFilter(clone);
    onFilterCountChangeHandle(clone2);
    props.filterChangedHandle(clone); // cloned object must be used because global filter is not yet updated
    if (filterVal !== "all") {
      searchParams.set("location_id", filterVal);
      searchParams.set("location_name", location.name);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      searchParams.delete("location_id");
      searchParams.delete("location_name");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
  };

  const addResource = () => {
    console.log("addResource Sidebar");
    props.setAdd(true);
  };
  // setting value will override events target value, used to manually trigger requests
  const queryLocationFilterSelectHandle = (e, value) => {
    const val = typeof value === "undefined" ? e.target.value : value;

    if (val.length > 0) {
      setLocationFilterState({
        value: val,
        isOpen: true,
      });

      props.dispatch(
        locationActions.getLocations({
          token: Biscuit.get("token"),
          filter: {
            findForSelect: true,
            q: val, // to-do: implement in backend
          },
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
    } else {
      props.dispatch(
        locationActions.getLocations({
          token: Biscuit.get("token"),
          filter: {
            findForSelect: true,
            //'q': val                                // to-do: implement in backend
          },
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );

      setLocationFilterState({
        value: val,
        isOpen: false,
      });
    }
  };

  const _export = () => {
    let params = "",
      count = 0;
    let clone = { ...globalFilter };
    for (const [type, val] of Object.entries(clone)) {
      if (count > 0) {
        params += "&" + type + "=" + val;
      } else {
        params += "?" + type + "=" + val;
      }
      count++;
    }

    const xmlHttp = new XMLHttpRequest();

    xmlHttp.open("GET", getApiHost() + "/resources/export" + params, true);

    //  xmlHttp.setRequestHeader('Accept', 'application/json')
    xmlHttp.setRequestHeader("Authorization", "Bearer " + Biscuit.get("token"));
    xmlHttp.setRequestHeader("Content-Language", language);
    xmlHttp.setRequestHeader("Accept-Language", language);
    xmlHttp.responseType = "blob";

    xmlHttp.onload = function () {
      const blob = new Blob([xmlHttp.response], { type: "application/xls" });
      FileSaver.saveAs(blob, t("resources") + ".xlsx");
    };

    xmlHttp.send(null);
  };

  const ClickHandler = (value) => {
    if (value === "export-xls") {
      _export();
    }
  };

  const getMenu = () => {
    let menu = [
      {
        text: t("export_xls", null, "capital"),
        href: "#",
        iconClass: "ico-inb inb-fi-excel",
        rel: "noopener noreferrer",
        title: "export-xls",
        id: "export-xls",
        handler: ClickHandler,
      },
      {
        spacer: true,
      },
    ];
    if (Biscuit.get("client.hasGPSLocks") === "true") {
      menu.push({
        text: t("reports_short", null, "capital"),
        href: "/reports?returnURL=resources" + searchParams,
        iconClass: "ico-inb inb-fi-list",
        rel: "noopener noreferrer",
        title: "reports",
        id: "reports",
      });
    }
    return menu;
  };

  return (
    <>
      <aside id="inb-c-sidebar" className="reservations-sidebar" style={{ float: "left" }}>
        <header className="inb-c-left-bar__title sticky-top">
          <h1 className="inb-page-title">{props.heading}</h1>
          <SidebarMenu menu={getMenu()} />
        </header>
        <div className="sticky-top-filter">
          <aside id="inb-selected-filters">
            {filterCount > 0 && (
              <ul>
                <p>
                  <i className="fi fi-filter"></i>
                  <span id="inb-selected-filters__count">{" " + filterCount}</span>

                  {" " + t("filter_selected")}
                  <a
                    href="#"
                    id="inb-selected-filters__unset"
                    className="unset-filter"
                    title={t("unselect_all_filter")}
                    onClick={() => {
                      resetFilter(true);
                    }}
                  >
                    x
                  </a>
                </p>
              </ul>
            )}
          </aside>
          {
            <SidebarFilter
              id="inb-c-left-bar-flist--resources-main"
              heading=""
              type="list"
              data={getFilterData(
                [
                  { name: t("all"), summaryItem: "allCount", value: "all" },
                  { name: t("active"), summaryItem: "activeCount", value: "active" },
                  { name: t("defect"), summaryItem: "defectCount", value: "defect" },
                  { name: t("inactive"), summaryItem: "inactiveCount", value: "inactive" },
                  {
                    name: t("inprogress", null, "capital"),
                    summaryItem: "inprogressCount",
                    value: "inprogress",
                  },
                ],
                props.summaryPending,
                props.summary,
              )}
              dataKey="value"
              selected={statusFilter}
              summaryPending={props.summaryPending}
              onChangeHandle={onStatusFilterChange}
            />
          }
          {/* {props.summaryPending && <>
                <div className="inb-image-box">
                    <img className="rollingLoader" src="assets/img/rolling_loader.svg"/>
                </div>
            </>*/}

          <ul>
            <span className="inb-list-title">{t("location", null, "capital")}</span>
            <div
              className={"inbooma-select-box" + (locationFilterState.isOpen ? "" : " close")}
              style={{ zIndex: "0" }}
            >
              <input
                className="inbooma-select-box__input"
                placeholder={t("select_${a}", { a: t("location", null, "capital") })}
                value={location == null ? locationFilterState.value : location.name}
                style={
                  location !== undefined && location != null
                    ? {
                        background: "#fff",
                        border: "1px solid #e3e3e3",
                        padding: "0.5rem",
                        fontSize: "0.9rem",
                        color: "#3b3b3b",
                        paddingRight: "20px",
                      }
                    : {}
                }
                onClick={() => {
                  setLocationFilterState({ ...locationFilterState, isOpen: true });
                }}
                onBlur={() => {
                  setLocationFilterState({ ...locationFilterState, isOpen: false });
                }}
                onChange={(e) => {
                  queryLocationFilterSelectHandle(e);
                }}
              />
              {location !== undefined && location !== null && (
                <a
                  href="#"
                  className="inbooma-select-box__reset"
                  onClick={() => locationFilterSelectHandle(undefined)}
                  style={{ float: "unset", paddingLeft: "15px" }}
                >
                  x
                </a>
              )}
              {_locationsResults.success === true && (
                <ul
                  className={
                    "inbooma-select-box-results" + (locationFilterState.isOpen ? "" : " hidden")
                  }
                >
                  {_locationsResults.data.map((loc, index) => {
                    return (
                      <li
                        className={
                          "inbooma-select-box-results__field" +
                          (typeof location !== "undefined" &&
                          location != null &&
                          location.id == loc.id
                            ? " selected"
                            : "")
                        }
                        key={loc.id}
                        value={loc.name}
                        onClick={() => {
                          locationFilterSelectHandle(loc);
                        }}
                      >
                        <span style={{ paddingRight: "10px" }}>{loc.name}</span>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </ul>
          <ul id="inb-c-left-bar-flist--resource-contingent" className="inb-vert-list">
            <span className="inb-list-title">{t("contingent", null, "capital")}</span>
            <select
              className="inbooma-select-box__input"
              name="contingents"
              onChange={(e) => onContingentFilterChange(e)}
              value={contingentFilter}
              placeholder={t("select_${a}", { a: t("contingent") })}
            >
              {contingents.map((contingent) => {
                return (
                  <>
                    <option key={contingent.id} value={contingent.id}>
                      {contingent.name}
                    </option>
                  </>
                );
              })}
            </select>
            {contingentFilter !== undefined && contingentFilter !== null && (
              <a
                href="#"
                className="inbooma-select-box__reset"
                onClick={() => onContingentFilterChange("all")}
                style={{ float: "unset", paddingLeft: "15px" }}
              >
                x
              </a>
            )}
          </ul>

          {Number(Biscuit.get("user.client_id")) === 7 && (
            <>
              <ul id="inb-c-left-bar-flist--external_resource_id" className="inb-vert-list">
                <span className="inb-list-title">
                  {t("external_resource_id_short", null, "capital")}
                </span>
                <br />
                <input
                  className="inbooma-input"
                  name="external_resource_id"
                  key={"sidebar_search_resource_nbr"}
                  style={{ maxWidth: "180px" }}
                  onChange={(e) => onResourceNbrFilterChange(e)}
                  value={resourceNbrFilter}
                ></input>
                {resourceNbrFilter !== undefined &&
                  resourceNbrFilter !== null &&
                  resourceNbrFilter !== "" && (
                    <a
                      href="#"
                      className="inbooma-select-box__reset"
                      onClick={() => onResourceNbrFilterChange("")}
                      style={{ float: "unset", paddingLeft: "88px" }}
                    >
                      x
                    </a>
                  )}
              </ul>
            </>
          )}
        </div>
        {/*   <footer
                className="inb-c-left-bar__footer small-only-float-container"
                data-inb-action-link="write">
                <a href="#"
                   id="toggle-left-bar"
                   className="button secondary show-for-small-only" onClick={(e) => onToggleLeftBar(e)}>
                    <i className="fi fi-filter"></i>
                    <span className="show-for-sr">{t('open_filter_menu')}</span>
                </a>
                { rbac.hasPermission('write') &&
                <NewResourceButton
                    addResource={addResource}
                />
                }
            </footer>*/}
        <SidebarFooter
          rbac={rbac}
          label={t("add_${a}", { a: t("resource", null, "capital") })}
          id="inb-c-left-bar-add-resource"
          url="resources/add"
          icon="fi-page-add"
          specialPermission="write"
        />
      </aside>
    </>
  );
};

export default ResourceSidebar;
